import React, { ReactNode } from 'react';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import styles from './GroupActivityHeaderFilter.module.scss';
import { FilterIcon } from '@components/Icons';
import { ActivityItemType } from '@models/Activity';
import SelectMenu from '@components/Menus/SelectMenu';
import { selectActiveGroupActivityFilter } from '@reducers/data/groupActivity';
import { setGroupActivityFilter } from '@actions/groupActivity';
import { useParams } from 'react-router-dom';

interface ActivityFilterOption {
  label: ReactNode;
  value: ActivityItemType;
}

export const titleForActivityFilterType: Partial<Record<ActivityItemType, string>> = {
  birthday: 'Birthdays',
  event: 'Events',
  news: 'News',
  diff: 'Social Changes',
  post: 'Posts',
  reconnect: 'Reconnect',
  reminder: 'Reminders',
};

const activityFilterOptions: ActivityFilterOption[] = [{ label: 'All', value: undefined }].concat(
  Object.keys(titleForActivityFilterType).map((value: ActivityItemType) => ({
    label: titleForActivityFilterType[value],
    value,
  })),
);

export default function GroupActivityFilterSetter({ disabled }: { disabled?: boolean }) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const filter = useSelector(selectActiveGroupActivityFilter);

  return (
    <SelectMenu
      className={styles.filter}
      options={activityFilterOptions}
      value={filter}
      onChange={(value) => dispatch(setGroupActivityFilter(id, value))}
      triggerClassName={cn(styles.filterTrigger, !!filter && styles.filterApplied)}
      disabled={disabled}
      triggerProps={{
        children: (
          <FilterIcon color="textPrimary" width="20" height="20" strokeWidth="1.2" hoverOpacity />
        ),
      }}
    />
  );
}
